import { shuffleArray } from '@/utils'
export default {
    namespaced: true,
    state: {
        AllowedRoles: {},
        NumberOfWerewolves: 2,
        Players: [],
        GameStarted: false
    },
    mutations: {
        UPDATE_NUMBEROFWEREWOLVES: (state, value) => state.NumberOfWerewolves = value,
        ResetPlayers: (state) => state.Players = [],
        AddPlayer: (state, name) => state.Players.push({ name }),
        RemovePlayer: (state, index) => state.Players.splice(index, 1),
        AssignRole: (state, { index, role }) => state.Players[index].role = role,
        StartGame: (state) => state.GameStarted = true,
        SetDead: (state, { index, dead }) => state.Players[index].dead = dead,
    },
    actions: {
        StartGame: ({ state, commit }) => {
            const NumberOfPlayers = state.Players.length
            let roles = Object.keys(state.AllowedRoles)
                .filter((role) => state.AllowedRoles[role])
                .filter((role) => !['Loup garou', 'Villageois'].includes(role))
            for (var i = 0; i < state.NumberOfWerewolves; i++) roles.push('Loup garou')
            if ( roles.length > NumberOfPlayers)
                throw Error(`Il faut au moins ${roles.length} joueurs`)
            const NumberOfVillagers = NumberOfPlayers - roles.length
            for (var i = 0; i < NumberOfVillagers; i++) roles.push('Villageois')
            shuffleArray(roles);
            for (var i = 0; i < NumberOfPlayers; i++){
                commit('AssignRole', { index: i, role: roles[i]})
                commit('SetDead', { index: i, dead: false })
            }
            commit('StartGame')
        }
    },
    getters: {
        NumberOfVillageoisAlive: (state) => {
            return state.Players.filter((p) => p.role != 'Loup garou' && !p.dead).length
        },
        NumberOfLoupsGarousAlive: (state) => {
            return state.Players.filter((p) => p.role == 'Loup garou' && !p.dead).length
        }
    }
}